<template>
  <app-modal modal-id="manne-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_manne") : $t("add_manne") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/mannes`">
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("manne_cate") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="select"
                  list-value-field="name"
                  :list="manneCateList"
                  :placeholder="$t('choose_an_manne_cate')"
                  v-model="formData.manne_cate"
                  :required="true"
                  :error-message="$errorMessage(errors, 'manne_cate')"
                  @change="onManneCateChange()"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("manne_type") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="select"
                  list-value-field="name"
                  :list="filteredManneTypeList"
                  :required="true"
                  :placeholder="$t('choose_an_manne_type')"
                  v-model="formData.manne_type_id"
                  :error-message="$errorMessage(errors, 'manne_type_id')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("size") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="text"
                  :placeholder="$t('enter_size')"
                  name="name"
                  v-model="formData.size"
                  :error-message="$errorMessage(errors, 'size')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4" v-if="!selectedUrl">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("code") }}</label>
            </div>
            <div class="col-sm-7">
              {{(mannesList.id + 1)}}
            </div>
          </div>
        </div>
        <div class="form-group mb-4" v-else>
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("code") }}</label>
            </div>
            <div class="col-sm-7">
              {{formData.id}}
            </div>
          </div>
        </div>



		  
		  
		  
		  
		






        

        
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";

export default {
  name: "ManneModal",
  mixins: [FormSubmitMixin],
  data() {
    return {
      isOrganizationModalActive: false,
      addMoreDetails: false,
      dataLoaded: false,
      countryList: [],
      filteredManneTypeList: [],
      formData: {
        owner_id: user.id,
        manne_cate: 1009
      },
      addEditData: {},
      customFieldValue:[],
      mannesList: [],
    };
  },
  computed: {
    ...mapGetters({
      manneTypeList: "manneType",
      manneCateList: "manneCate",
	 
	 
    }),
 


  },
  methods: {
    onManneCateChange() {
      this.formData.manne_type_id = '';
    this.updateFilteredManneTypeList();
  },

  updateFilteredManneTypeList() {
    if (this.formData.manne_cate) {
      const selectedManneCate = this.manneCateList.find(
        (manneCate) => manneCate.id === parseInt(this.formData.manne_cate)
      );

      if (selectedManneCate && selectedManneCate.type) {
        this.filteredManneTypeList = this.manneTypeList.filter(
          (manneType) => manneType.type === selectedManneCate.type
        );
      }
    } else {
      this.filteredManneTypeList = [];
    }
  },
    getMannes() {
          
          this.axiosGet(`crm/mannesnum`)
            .then((response) => {
              this.mannesList = response.data;
              
            })
            .catch(({ error }) => {
            })
            .finally(() => {
                this.dataLoaded = true;
            });
        },
   
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
		this.addEditData.size = this.formData.size;
      this.addEditData.manne_type_id = this.formData.manne_type_id;
      this.addEditData.manne_cate = this.formData.manne_cate;
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
   
    },
   
  },
  mounted() {
    this.onManneCateChange();

  },
  created(){
    this.$store.dispatch('manneType');
    this.$store.dispatch('manneCate');
    this.getMannes();
  },
 


};
</script>
